import styled from 'styled-components'
import media from 'styled-media-query'

export const Container = styled.ul`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  background: var(--primary);
  padding: 0;
  border-radius: 0 0 16px 16px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08);
  margin: 0 auto;
  list-style-type: none;
  width: 100%;
  max-width: 1200px;

  ${media.lessThan('medium')`
    justify-content: center;
    flex-wrap: wrap;
    padding: 10px;
  `}

  li {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 2rem;
    padding-right: 2rem;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
    transition: background-color 0.2s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
      cursor: pointer;
    }

    a {
      color: #fff;
      font-weight: 500;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-decoration: none;
      
      svg {
        font-size: 22px;
        margin-right: 10px;
        color: #fff;
      }
      
      span {
        margin-left: 8px;
        font-weight: 500;
      }
    }

    &.actived {
      background: #fff;
      border-bottom: none;
      position: relative;
      box-shadow: 0 -5px 10px rgba(0, 0, 0, 0.05);
      
      &:hover {
        background: #fff;
      }
      
      a {
        color: #000;
        text-decoration: none;
        
        svg {
          color: var(--secondary);
        }
      }
    }
    
    ${media.lessThan('medium')`
      padding: 10px;
      margin: 0 5px;
      border-radius: 50%;
      width: 46px;
      height: 46px;
      justify-content: center;
      
      a {
        display: flex;
        align-items: center;
        justify-content: center;
        
        svg {
          margin-right: 0;
          font-size: 22px;
        }
      }
      
      &.actived {
        &::after, &::before {
          display: none;
        }
      }
    `}
  }
`
